import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { saveUserProfileToSessionStorage } from 'reducers/userprofile/userprofileSessionStorage'

export interface UserProfile {
  isActive: boolean
  givenName: null | string
  middleName: null | string
  suffix: null | string
  familyName: null | string
  homePhone: null | string
  mobilePhone: null | string
  workPhone: null | string
  emailAddress: null | string
  street: null | string
  zip: null | string
  city: null | string
  state: null | string
  contactType: number | null
}

const initialState: UserProfile = {
  isActive: false,
  givenName: null,
  middleName: null,
  suffix: null,
  familyName: null,
  homePhone: null,
  mobilePhone: null,
  workPhone: null,
  emailAddress: null,
  street: null,
  zip: null,
  city: null,
  state: null,
  contactType: null
}

export function getEmptyUserProfile(): UserProfile {
  const userProfile: UserProfile = {
    isActive: false,
    givenName: null,
    middleName: null,
    suffix: null,
    familyName: null,
    homePhone: null,
    mobilePhone: null,
    workPhone: null,
    emailAddress: null,
    street: null,
    zip: null,
    city: null,
    state: null,
    contactType: null
  }
  return userProfile
}

const userProfile = createSlice({
  name: 'userProfile',
  initialState: initialState,
  reducers: {
    setUserProfile(state, { payload }: PayloadAction<UserProfile>) {
      saveUserProfileToSessionStorage(payload)
      return payload
    },
    setMobilePhone(state, { payload }: PayloadAction<string>) {
      state.mobilePhone = payload
    },
    setEmailAddress(state, { payload }: PayloadAction<string>) {
      state.emailAddress = payload
    }
  }
})

export const { setUserProfile, setMobilePhone, setEmailAddress } =
  userProfile.actions

export default userProfile.reducer
